import {MaxLength} from './text'

export const DeliveryMethod = {
    /** 택배,등기,소포 */
    DELIVERY: 'DELIVERY',
    /** 굿스플로 송장출력 */
    GDFW_ISSUE_SVC: 'GDFW_ISSUE_SVC',
    /** 방문수령 */
    VISIT_RECEIPT: 'VISIT_RECEIPT',
    /** 직접전달 */
    DIRECT_DELIVERY: 'DIRECT_DELIVERY',
    /** 퀵서비스 */
    QUICK_SVC: 'QUICK_SVC',
    /** 배송없음 */
    NOTHING: 'NOTHING',
    /** 지정방문택배 */
    DELIVERY_DESIGNATED: 'DELIVERY_DESIGNATED',
    /** 편의점택배예약 */
    CONVENIENCE_DELIVERY: 'CONVENIENCE_DELIVERY',
    /** 지정 반품택배 */
    RETURN_DESIGNATED: 'RETURN_DESIGNATED',
    /** 일반 반품택배 */
    RETURN_DELIVERY: 'RETURN_DELIVERY',
    /** 직접반송 */
    RETURN_INDIVIDUAL: 'RETURN_INDIVIDUAL',
    /** 수거정보없음(구매자 미입력) */
    RETURN_VALUE_NULL: 'RETURN_VALUE_NULL',
    /** 판매자 직접 수거 */
    RETURN_MERCHANT: 'RETURN_MERCHANT',
    /** 알수없음(예외처리에 사용.) */
    UNKNOWN: 'UNKNOWN',
} as const

export type DeliveryMethodType = Constant<typeof DeliveryMethod>

export const DeliveryFeePay = {
    /** 착불 또는 선결제 */
    PRE_OR_AFTER_PAY: 'PRE_OR_AFTER_PAY',
    /** 선결제 */
    PRE_PAY: 'PRE_PAY',
    /** 착불 */
    AFTER_PAY: 'AFTER_PAY',
    /** 무료 */
    FREE: 'FREE',
    /** 미노출. FE 에서만 관리되는 값. */
    NONE: 'NONE',
} as const

export type DeliveryFeePayType = Constant<typeof DeliveryFeePay>

export const DeliveryFeeClass = {
    /** 무료 */
    FREE: 'FREE',
    /** 조건부무료 */
    CONDITIONAL_FREE: 'CONDITIONAL_FREE',
    /** 구간별 부과 */
    SECTION_BY_QUANTITY: 'SECTION_BY_QUANTITY',
    /** 유료 */
    CHARGE: 'CHARGE',
    /** 수량별 반복 부과 */
    REPEAT_BY_QUANTITY: 'REPEAT_BY_QUANTITY',
    /** 수량할증 */
    CHARGE_BY_QUANTITY: 'CHARGE_BY_QUANTITY',
} as const

/** 상세 > 상품묶음그룹 모델 배송비 결제 구분 */
export const DeliveryFeeRatingClass = {
    /** 선결제 */
    PREPAYED: 'PREPAYED',
    /** 착불 */
    CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
    /** 무료 */
    FREE: 'FREE',
    /** 착불 OR 선결제 */
    CASH_ON_DELIVERY_OR_PREPAYED: 'CASH_ON_DELIVERY_OR_PREPAYED',
} as const

export type DeliveryFeeRatingClassType = Constant<typeof DeliveryFeeRatingClass>

export const SameDayDispatch = {
    /**
     * holidayOfTheWeek | 판매자휴무요일
     * noSalesDay       | 영업일이아님
     * sellerHoliday    | 판매자휴무일
     **/
    NOT_BUSINESS_DAY: 'NOT_BUSINESS_DAY',
    /**
     * overdueTime     | 기준시간지남
     **/
    EXCEED_DEADLINE: 'EXCEED_DEADLINE',
    AVAILABLE: 'AVAILABLE',
    /**
     * 수량부족, 재고부족, 품절
     */
    RELATED_STOCK: 'RELATED_STOCK',
} as const

/** 수령 위치 */
export const PickUpLocation = {
    /** 문 앞 */
    FRONT_OF_DOOR: 'FRONT_OF_DOOR',
    /** 경비실 보관 */
    MANAGEMENT_OFFICE: 'MANAGEMENT_OFFICE',
    /** 직접 수령 */
    DIRECT_RECEIVE: 'DIRECT_RECEIVE',
    /** 기타 */
    OTHER: 'OTHER',
} as const

export type PickUpLocationType = Constant<typeof PickUpLocation>
export type PickUpLocationValueType = 'ODH5FRTODR' | 'ODH5MGNOFC' | 'ODH5DRRCV' | 'ODH5OTHER'

export const PickUpLocationMap: Record<
    PickUpLocationType,
    {
        id: string
        label: string
        selectLabel: string
        value: PickUpLocationValueType
    }
> = {
    [PickUpLocation.FRONT_OF_DOOR]: {
        id: 'location1',
        label: '문 앞',
        selectLabel: '문 앞에 놓아주세요',
        value: 'ODH5FRTODR',
    },
    [PickUpLocation.MANAGEMENT_OFFICE]: {
        id: 'location2',
        label: '경비실 보관',
        selectLabel: '경비실에 맡겨주세요',
        value: 'ODH5MGNOFC',
    },
    [PickUpLocation.DIRECT_RECEIVE]: {
        id: 'location3',
        label: '직접 수령할게요',
        selectLabel: '직접 받을게요',
        value: 'ODH5DRRCV',
    },
    [PickUpLocation.OTHER]: {
        id: 'location4',
        label: '기타',
        selectLabel: '기타',
        value: 'ODH5OTHER',
    },
} as const

/** 출입 방법 */
export const EntryMethod = {
    /** 공동현관 비밀번호 */
    LOBBY_PW: 'LOBBY_PW',
    /** 경비실 호출 */
    MANAGEMENT_OFFICE: 'MANAGEMENT_OFFICE',
    /** 자유 출입 가능 */
    FREE: 'FREE',
    /** 기타 출입 방법 */
    OTHER: 'OTHER',
} as const

export type EntryMethodType = Constant<typeof EntryMethod>

export const EntryMethodMap: Record<
    EntryMethodType,
    {
        id: string
        label: string
        value: string
        textarea?: {
            title: string
            placeholder: string
            notice?: string
        }
    }
> = {
    [EntryMethod.LOBBY_PW]: {
        id: 'acces_method1',
        label: '공동현관',
        value: 'ODH6LBYPW',
        textarea: {
            title: '출입 방법',
            placeholder: '자세히 적어주세요. (예 : #1234 호출)',
            notice: '잘못 입력하거나 새벽·휴일 등 출입 제한 시 배송 불가해요.',
        },
    },
    [EntryMethod.MANAGEMENT_OFFICE]: {
        id: 'acces_method2',
        label: '경비실 호출',
        value: 'ODH6MGNOFC',
        textarea: {
            title: '출입 방법',
            placeholder: '(선택) 호출 방법을 적어주세요.',
            notice: '경비실 부재나 새벽·휴일 등 출입 제한 시 배송 불가해요.',
        },
    },
    [EntryMethod.FREE]: {
        id: 'acces_method3',
        label: '비밀번호 없는 자유출입',
        value: 'ODH6FREE',
    },
    [EntryMethod.OTHER]: {
        id: 'acces_method4',
        label: '기타',
        value: 'ODH6OTHER',
        textarea: {
            title: '출입 방법',
            placeholder: '출입 방법을 자세히 적어주세요.',
        },
    },
}

export const DeliveryAttributeCode = {
    /** 일반배송 */
    NORMAL: 'NORMAL',
    /** 당일발송 */
    TODAY: 'TODAY',
    /** 옵션별 당일발송 */
    OPTION_TODAY: 'OPTION_TODAY',
    /** 희망일배송 */
    HOPE: 'HOPE',
    /** 당일배송 */
    TODAY_ARRIVAL: 'TODAY_ARRIVAL',
    /** 새벽배송 */
    DAWN_ARRIVAL: 'DAWN_ARRIVAL',
    /** 예약구매 */
    PRE_ORDER: 'PRE_ORDER',
    /** 네이버 도착보장 */
    ARRIVAL_GUARANTEE: 'ARRIVAL_GUARANTEE',
    /** 판매자 도착보장 */
    SELLER_GUARANTEE: 'SELLER_GUARANTEE',
    /** 판매자 희망일 도착보장 */
    HOPE_SELLER_GUARANTEE: 'HOPE_SELLER_GUARANTEE',
    /** 배달 */
    QUICK: 'QUICK',
    /** 픽업 */
    PICKUP: 'PICKUP',
    /** 퀵커머스 */
    QUICK_PICKUP: 'QUICK_PICKUP',
} as const

export type DeliveryAttributeCodeType = Constant<typeof DeliveryAttributeCode>

/**
 * 주문서 > 배송지영역 스크린
 */
export const DeliverySheetId = {
    /** 수령위치 변경 */
    PICKUP_LOCATION: 'PICKUP_LOCATION',
} as const

export type DeliverySheetIdType = Constant<typeof DeliverySheetId>

export const DeliveryRecipient = {
    /** 받은 사람이 배송지 입력 */
    GIFT: 'GIFT',
    /** 주문자가 배송지 입력 */
    NORMAL: 'NORMAL',
} as const

export type DeliveryRecipientType = Constant<typeof DeliveryRecipient>

export const OverseaDeliveryCustom = {
    /** 개인통관 */
    INDIVIDUAL_CUSTOM_UNIQUE_CODE: 'INDIVIDUAL_CUSTOM_UNIQUE_CODE',
    /** 사업자통관 */
    BUSINESS_CUSTOM_CODE: 'BUSINESS_CUSTOM_CODE',
    /** 주민 등록 번호 */
    SOCIAL_SECURITY_NUMBER: 'SOCIAL_SECURITY_NUMBER',
}
export type OverseaDeliveryCustomType = Constant<typeof OverseaDeliveryCustom>

/** 지번 주소 우편번호 길이 */
export const LOT_NUMBER_ADDRESS_ZIPCODE_LENGTH = 6

export const DELIVERY_MEMO = {
    /** 배송메모를 선택해주세요 */
    INITIAL: 'INITIAL',
    /** 선택 안 함 */
    NOTHING: 'NOTHING',
    /** 편집 폼에 입력한 메모 */
    WRITTEN: 'WRITTEN',
    /** 기본 메모 */
    COMMON: 'COMMON',
} as const

export type DeliveryMemoType = Constant<typeof DELIVERY_MEMO>

/** 수령위치/출입방법 팝업 postmessage key */
export const DELIVERY_INSTRUCTION_POST_MESSAGE_KEY = 'deliveryInstructionPostMessageKey'

/** 배송정보 변경 postmessage key */
export const DELIVERY_MANAGER_LOADED = 'deliveryManagerPopupWindowLoaded'
export const DELIVERY_MANAGER_INITIALIZE_DATA_SENDED = 'deliveryManagerInitializeDataSendedFromParentWindow'
export const DELIVERY_MANAGER_COMPLETED = 'deliveryInfoSelectCompletedAtPopupDeliveryManager'

export const DELIVERY_ALERT_MESSAGE = {
    MAX_PICKUP_CONTENT: `최대 ${MaxLength.PICKUP_MEMO}자까지 입력할 수 있습니다.`,
    MAX_ENTRY_CONTENT: `최대 ${MaxLength.ENTRY_MEMO}자까지 입력할 수 있습니다.`,
}

export const SelectedZipCodeValidateReason = {
    INIT: 'INIT',
    REFRESH: 'REFRESH',
    DELIVERY_CHANGE: 'DELIVERY_CHANGE',
} as const

export type SelectedZipCodeValidateReasonValue = Constant<typeof SelectedZipCodeValidateReason>

export const ZipCodeSize = {
    FIVE: 5,
    SIX: 6,
}

export const PersonalCustomsClearanceScene = {
    IDLE: 'IDLE',
    SELF: 'SELF',
    SELF_INPUT: 'SELF_INPUT',
    SELF_NOT_FOUND_CODE: 'SELF_NOT_FOUND_CODE',
    SELF_INVALID_CODE: 'SELF_INVALID_CODE',
    SELF_INVALID_ZIPCODE: 'SELF_INVALID_ZIPCODE',
    OTHER_INPUT_MFA: 'OTHER_INPUT_MFA',
    OTHER_INPUT: 'OTHER_INPUT',
    OTHER_INVALID_CODE: 'OTHER_INVALID_CODE',
    OTHER_INVALID_INPUT: 'OTHER_INVALID_INPUT',
    OTHER_INVALID_TEL_NO: 'OTHER_INVALID_TEL_NO',
    OTHER_INVALID_NAME: 'OTHER_INVALID_NAME',
    OTHER_NOT_FOUND_CODE: 'OTHER_NOT_FOUND_CODE',
    BRIDGE_FAIL: 'BRIDGE_FAIL',
    FAIL: 'FAIL',
    BRIDGE: 'BRIDGE',
    DONE: 'DONE',
} as const

export type PersonalCustomsClearanceSceneType = Constant<typeof PersonalCustomsClearanceScene>

export const PassPersonalCustomsClearanceScenes: PersonalCustomsClearanceSceneType[] = [
    PersonalCustomsClearanceScene.IDLE,
    PersonalCustomsClearanceScene.DONE,
]

export const PersonalCustomsClearanceErrorCase = {
    /** 납세의무자 개인통관고유부호가 존재하지 않습니다. */
    NOT_FOUND_CODE: 'NOT_FOUND_CODE',
    /** 해당 납세의무자의 개인통관고유부호는 사용할 수 없는 상태입니다. */
    INVALID_CODE: 'INVALID_CODE',
    /** 납세의무자 휴대전화번호가 일치하지 않습니다. */
    INVALID_TEL_NO: 'INVALID_TEL_NO',
    /** 입력하신 우편번호가 개인통관고유부호 우편번호(배송주소)와 일치하지 않습니다. */
    INVALID_ZIPCODE: 'INVALID_ZIPCODE',
    /** 개인통관고유부호의 성명과 일치하지 않습니다. */
    INVALID_NAME: 'INVALID_NAME',
    /** 모르는 메시지로 왔을 경우 */
    UNKNOWN: 'UNKNOWN',
} as const

export type PersonalCustomsClearanceErrorCaseType = Constant<typeof PersonalCustomsClearanceErrorCase>

/** 주소 검증 결과 타입 */
export const DELIVERY_VALIDATION_RESULT_TYPE = {
    /** 선택 가능 */
    VALID: 'VALID',
    /** Confirm Alert 노출 (user의 확인 받고 선택 가능) */
    WARNING: 'WARNING',
    /** 선택 불가능 */
    INVALID: 'INVALID',
} as const

export type DeliveryValidationResultTypeValue = Constant<typeof DELIVERY_VALIDATION_RESULT_TYPE>

export const AddressBookResponseCode = {
    SUCCESS: '2001',
    NOT_EXIST: '4001',
    ALREADY_EXIST: '4006',
    PRIMARY: '4008',
    MAX_REGISTERED_ADDRESS: '4011',
    BASE_ADDRESS_NO_KOREAN: '4014',
    ADDRESS_REF_EXIST: '4015',
} as const

const ReferencedServiceCodeMap: Record<string, string> = {
    SUBSCRIPTION: '정기구독',
    FLEA_MARKET: 'N플리마켓',
} as const

const ServiceCodeMapFn = (serviceCode: string): string => {
    return ReferencedServiceCodeMap[serviceCode] || serviceCode
}

const getAddressRefExistErrorMessage = ({
    method,
    usingServices = [],
}: {
    method: 'put' | 'delete' | 'post'
    usingServices?: string[]
}): string => {
    const serviceTitles = usingServices.map(ServiceCodeMapFn).join(', ')

    if (method === 'delete') {
        return `${serviceTitles} 상품에 설정된 배송지는 삭제할 수 없습니다.`
    } else {
        return `${serviceTitles} 상품에 설정된 배송지는 수정할 수 없습니다. 배송지를 새로 등록해주시거나, ${serviceTitles} 상품정보를 확인해주세요.`
    }
}

export const AddressBookRequestFailMessage = {
    [AddressBookResponseCode.NOT_EXIST]: '이미 삭제된 배송지입니다.',
    [AddressBookResponseCode.ALREADY_EXIST]: '동일한 배송지가 존재합니다. 수정 후 다시 시도해주세요.',
    [AddressBookResponseCode.PRIMARY]: '다른 배송지를 기본배송지로 설정 후 삭제해주세요.',
    [AddressBookResponseCode.MAX_REGISTERED_ADDRESS]:
        '저장가능한 배송지 개수를 초과하였습니다. 배송지를 삭제하고 새로 등록해주세요.',
    [AddressBookResponseCode.BASE_ADDRESS_NO_KOREAN]: '정확한 배송을 위해 배송지를 한글명으로 변경해주세요.',
}

export const isAddressBookRequestFailMessageKey = (key: string): key is keyof typeof AddressBookRequestFailMessage => {
    return key in AddressBookRequestFailMessage
}

export const AddressBookRequestFailMessageGetter = {
    [AddressBookResponseCode.ADDRESS_REF_EXIST]: getAddressRefExistErrorMessage,
}

export const isAddressBookRequestFailMessageGetterKey = (
    key: string,
): key is keyof typeof AddressBookRequestFailMessageGetter => {
    return key in AddressBookRequestFailMessageGetter
}

export const DefaultAddressBookRequestFailMessage = '일시적인 오류입니다. 다시 시도해주세요.'

export const DELIVERY_MEMO_ERROR_MESSAGE = {
    MEMO_INCLUDE_INVISIBLE_CHAR_FAIL: '배송메모에 사용불가한 특수문자가 있습니다. 다시 입력해주세요.',
    REQUEST_MEMO_INCLUDE_INVISIBLE_CHAR_FAIL: '결제요청 메모에 사용불가한 특수문자가 있습니다. 다시 입력해주세요.',
    NO_DELIVERY_RECEIVER_MEMO_INCLUDE_INVISIBLE_CHAR_FAIL:
        '수신자 요청메모에 사용불가한 특수문자가 있습니다. 다시 입력해주세요.',
    MEMO_MAX_FAIL: `배송메모는 최대 ${MaxLength.DELIVERY_MEMO}자까지 입력 가능합니다.`,
} as const

/** 수령위치 필요성 타입 */
export const PickupLocationNecessityType = {
    /** 필수 */
    ESSENTIAL: 'ESSENTIAL',
    /** 선택 */
    OPTIONAL: 'OPTIONAL',
    /** 필요 없음 */
    NONE: 'NONE',
} as const

export type PickupLocationNecessityTypeValues = Constant<typeof PickupLocationNecessityType>
